<!--
 * @Author: Chenhw2017 1272617071@qq.com
 * @Date: 2024-06-11 13:57:10
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-06-12 15:02:38
 * @FilePath: /partner.chaoyongtuan.com/src/views/settings/message/components/index/compose/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="fz-14 flex-row-align-center">
		<div class="color-gy-8 mr-16 text-align-right" style="width:60px">{{ info.label }}</div>
		<div class="color-gy-9" style="line-height:30px">
			<div style="float:left" class="flex-row flex-align-start" v-for="(item, index) in info.content.list" :key="index">
				<span v-if="desc[index]" class="pr-8">{{ desc[index] }}</span>
				<inputCom class="pr-8" :ref="item.send_key" v-if="item.type == 'input'" :info="item" />
				<selectCom class="pr-8" :ref="item.send_key" v-if="item.type == 'select'" :info="item" />
			</div>
			<span>{{ desc[desc.length - 1] }}</span>
		</div>
	</div>
</template>

<script>
import inputCom from './inputCom';
import selectCom from './selectCom';
export default {
	props: {
		info: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	components: {
		inputCom,
		selectCom,
	},
	computed: {
		desc() {
			return this.info.content.str.split('{{yx_replace_value}}');
		},
	},
	methods: {
		async getValue() {
			const params = [];
			for (let i = 0; i < this.info.content.list.length; i++) {
				const item = this.info.content.list[i];
				const val = await this.$refs[item.send_key][0].getValue();
				params.push({
					send_key: item.send_key,
					select_value: val,
				});
			}
			return params;
		},
	},
};
</script>

<style></style>
